import React from 'react';
import commonService from 'core/common/service/commonService';
import {SECURABLE_TYPE, PERMISSION, PageProps, ID} from "core/metamodel/metaConstant";
import {History} from "react-router";
import {DomainAncestor} from "core/common/domain/DomainAncestor";
import last = require("lodash/last");
import {UserContextDto} from "core/security/securityDomain";
import securityService from "core/security/securityService";
import {action} from "mobx";
import ConfirmationDialog from "core/components/confirmationDialog/confirmationDialog";
import {Movable, MovingBlocks} from "core/grid/gridUtils";
import {GridDocument, GridDocumentsParams} from "core/document/gridDocument";
import documentService from "core/document/documentService";
import {Document} from "core/document/documentDomain";
import {handleFavicon, removeFaviconLink} from "core/common/utils/favicon";
import {loc} from "../config/locales";
import PropTypes from "prop-types";


export default class PageAncestor<P extends PageProps, S> extends React.Component<P,S> {

  static contextTypes = {
    router: PropTypes.func.isRequired,
  };

  static handler: any;

  static willTransitionTo(transition, params, query, callback) {
    console.log('willTransitionTo: transition = %O, params = %O, query = %O, route = %s, module = %s', transition, params, query, this.name, this.handler.module);

    // check if autenticated
    let currentUser = securityService.currentUser;

    if (!currentUser) {
      securityService.readCurrentUserContext()
        .then((userContextDto: UserContextDto) => {

          if (userContextDto) {
            securityService.setUserContextDto(userContextDto);

            window.sessionStorage.setItem('tenantId', securityService.currentTenant.tenantId.toString());
            window.TENANT_ID = securityService.currentTenant.tenantId.toString();

            let _cachedSRT = window.localStorage.getItem("serverRestartTime");

            if (userContextDto.serverRestartTime !== _cachedSRT) {
              console.log('Cached SRT %s, server SRT %s -> going to clear cache', _cachedSRT, userContextDto.serverRestartTime);
              window.localStorage.clear();
              window.localStorage.setItem("serverRestartTime", userContextDto.serverRestartTime);
            }

            if (this.handler.protectedPage && !securityService.hasRight((typeof this.handler.protectedPage === 'boolean') ? this.name : this.handler.protectedPage, PERMISSION.Read)) {
              console.warn("No Read permission to " + this.handler.title);
              transition.abort();
            }

            handleFavicon(this.handler);
          } else {
            commonService.redirectAfterLogin =transition.path;
            transition.redirect('loginPage');
          }

          callback();
        });
      return;
    }

    if (this.handler.protectedPage && !securityService.hasRight( (typeof this.handler.protectedPage === 'boolean') ? this.name : this.handler.protectedPage, PERMISSION.Read)) {
      console.warn("No Read permission to " + this.name);
      transition.abort();
    }

    handleFavicon(this.handler);
    callback();
  }


  static willTransitionFrom(transition, component, callback) {
    console.log('willTransitionFrom: transition = %O, component = %O', transition, component);

    let rootObject, origComponent = component;

    // // redux unwrap
    // if (typeof component.getWrappedInstance === 'function') {
    //   try {
    //     origComponent = component.getWrappedInstance();
    //   } catch (e) {
    //     console.log('getWrappedInstance error: ', e);
    //   }
    // }

    // react-dnd unwrap
    if (component.refs.child) {
      origComponent = component.refs.child;
    }

    rootObject = (origComponent && typeof origComponent.findRootObject === 'function') ? origComponent.findRootObject() : undefined;

    if (rootObject && rootObject.$dirty) {
      new Promise((resolve, reject) => {
        origComponent.dirtyDialogRef.open(resolve, reject);
      })
      .then(() => {
        callback();
      })
      .catch((e) => {
        transition.cancel();
      });
      return;
    } else {
      callback();
    }

    removeFaviconLink();
  }

  private dirtyDialogRef: ConfirmationDialog;
  public dirtyDialogRefHandler = c => this.dirtyDialogRef = c;

  private deletedDialogRef: ConfirmationDialog;
  public deleteDialogRefHandler = c => this.deletedDialogRef = c;

  public openDeleteDialog () : Promise<any> {
    return new Promise((resolve, reject) => {
      this.deletedDialogRef.open(resolve, reject, loc.i18n`Do you really want to delete this item?`);
    })
  }

  public onBack = (evt) => {
    this.context.router.goBack();
  };


  public goBackOrHome = () => {
    if (History.length <= 1) {
      this.context.router.transitionTo('home');
    } else {
      this.context.router.goBack();
    }
  };

  public idChanged(oldId: ID, newId: ID) {
    return (this.properId(newId) && newId !== oldId);
  }

  public properId(id: ID) : boolean {
    return (id && id !== 'copy'  && id !== 'new');
  }

  public findRootObject() : DomainAncestor {
    return null;
  }

  protected onTabChange = (tabName) => {
    this.tabChange(tabName, (tab) => {
      this.findRootObject().$movingBlocks.activeBlockTab = tab;
    } );
  };



  protected tabChange(tabName: string, storeFn: (tab: string) => void) {
    if (tabName && !!(tabName as any).target) return; // workaround kvuli material-ui error https://github.com/callemall/material-ui/issues/2189

    console.log('onTabChange ', tabName);

    storeFn(tabName);

    let routeName = last<any>(this.context.router.getCurrentRoutes()).name,
      params = this.props.params,
      query = Object.assign({}, this.props.query, {tab: tabName});

    let path = this.context.router.makePath(routeName, params, query);
    window.history.replaceState({path: path}, '', path);

    //this.context.router.replaceWith(routeName, params,query);

    console.log("%c query", "color: red", this.context.router.getCurrentQuery());
  }



  /**
   * Grid k aktivaci (init + search v timeoutu)
   * @param grid
   */
  @action protected activateTab(grid: Movable) {
    if (!grid.data) {
      grid.search(this.findRootObject(), true);
    }
  }

  protected mediaQueryListener = (changed) => {
    console.log('mediaQueryListener islarge = ' + changed.matches);
    const obj = this.findRootObject();
    obj.$movingBlocks.fixActiveTab();
    this.forceUpdate();

    setTimeout( () => {
      obj.$movingBlocks.searchExposedGrids(obj);
    }, 0);
  };


  protected  docSavingPromise(gridDocument: GridDocument, params: GridDocumentsParams): Promise<any> {

    let promise: Promise<any> = Promise.resolve(null);

    if (gridDocument && gridDocument.documents) {
      let newDocs: Document[] = gridDocument.documents.filter(d => d.$new);
      if (newDocs.length) {
        promise = Promise.all(newDocs.map(doc => documentService.saveDocument(doc, params)));
      }
    }

    return promise;
  }



}





// WEBPACK FOOTER //
// ./src/core/common/page/pageAncestor.ts